module.exports = __webpack_public_path__ + "img/ic-account.d1e1845d.svg";